
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/liveramp",
      function () {
        return require("private-next-pages/destinations/liveramp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/liveramp"])
      });
    }
  